import { createFileRoute } from "@tanstack/react-router";
import {
  motionAmplificationJobsQueryOptions,
  useMotionAmplificationJobsQuery,
} from "../queries/useMotionAmplificationJobsQuery";
import { MotionAmplificationScreen } from "../screens/MotionAmplificationScreen";

export const Route = createFileRoute("/_app/motion-amplification")({
  loader: ({ context }) =>
    context.queryClient.ensureInfiniteQueryData(
      motionAmplificationJobsQueryOptions(),
    ),
  component: MotionAmplificationRoute,
});

function MotionAmplificationRoute() {
  const jobsQuery = useMotionAmplificationJobsQuery();

  return <MotionAmplificationScreen jobsQuery={jobsQuery} />;
}
